import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useDividendsDistributionModal } from '../context/DividendsDistributionModalContext';
import DividendsDistributionModalScriptureView from './DividendsDistributionModalScriptureView';
import DividendsDistributionModalDataView from './DividendsDistributionModalDataView';

const DividendsDistributionModalBody: FC = () => {
  const { data } = useDividendsDistributionModal();

  return (
    <>
      <Modal.Body>
        <div className="nk-modal">
          {data.scriptureView ? (
            <DividendsDistributionModalScriptureView />
          ) : (
            <DividendsDistributionModalDataView />
          )}
        </div>
      </Modal.Body>
    </>
  );
};

export default DividendsDistributionModalBody;
